import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Handles the Google OAuth return: reads #session_id, exchanges it, then redirects.
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (sessionId) {
        try {
          await loginWithGoogleSession(sessionId);
        } catch { /* fall through */ }
      }
      window.history.replaceState(null, "", "/account");
      navigate("/account", { replace: true });
    })();
  }, [location.hash, loginWithGoogleSession, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-cream">
      <p className="font-serif text-2xl text-ink">Accesso in corso…</p>
    </div>
  );
};
